
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.763 19.41L17.413 18.531C17.236 18.085 16.961 17.685 16.609 17.359L16.545 17.3C15.991 16.786 15.263 16.5 14.507 16.5H9.49296C8.73696 16.5 8.00896 16.786 7.45396 17.299L7.38996 17.359C7.03796 17.685 6.76396 18.085 6.58596 18.531L6.23596 19.41","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.4749 7.94701C15.8417 9.31385 15.8417 11.5299 14.4749 12.8968C13.108 14.2636 10.892 14.2636 9.52513 12.8968C8.15829 11.5299 8.15829 9.31385 9.52513 7.94701C10.892 6.58017 13.108 6.58017 14.4749 7.94701","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.3639 6.13604C21.8787 9.65076 21.8787 15.3492 18.3639 18.8639C14.8492 22.3787 9.15074 22.3787 5.63604 18.8639C2.12132 15.3492 2.12132 9.65074 5.63604 6.13604C9.15076 2.62132 14.8492 2.62132 18.3639 6.13604","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    